<template>
    <svg class="fns ath-visual-smiley" :class="[cname]" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
        <!-- eslint-disable @stylistic/max-len -->
        <template v-if="cname === 'bad'">
            <path d="M64,3A61,61,0,1,1,3,64,61.06,61.06,0,0,1,64,3m0-3a64,64,0,1,0,64,64A64,64,0,0,0,64,0Z" />
            <path d="M86.26,94.81a1.47,1.47,0,0,1-.85-.26,38,38,0,0,0-24.09-6.7A37.48,37.48,0,0,0,42.6,94.54a1.5,1.5,0,1,1-1.72-2.46,40.5,40.5,0,0,1,20.23-7.22,41,41,0,0,1,26,7.22,1.5,1.5,0,0,1-.85,2.73Z" />
            <path d="M43.83,60.63a9.34,9.34,0,0,1-8.28-5,1.5,1.5,0,1,1,2.64-1.41,6.39,6.39,0,0,0,11.27,0,1.5,1.5,0,1,1,2.65,1.41A9.37,9.37,0,0,1,43.83,60.63Z" />
            <path d="M85.57,60.63a9.34,9.34,0,0,1-8.28-5,1.5,1.5,0,1,1,2.64-1.41,6.39,6.39,0,0,0,11.27,0,1.5,1.5,0,1,1,2.64,1.41A9.34,9.34,0,0,1,85.57,60.63Z" />
        </template>
        <template v-if="cname === 'good'">
            <path d="M64,3A61,61,0,1,1,3,64,61.06,61.06,0,0,1,64,3m0-3a64,64,0,1,0,64,64A64,64,0,0,0,64,0Z" />
            <path d="M90.09,56.8H81a1.5,1.5,0,0,1,0-3h9a1.5,1.5,0,0,1,0,3Z" />
            <path d="M47,56.8H37.91a1.5,1.5,0,0,1,0-3H47a1.5,1.5,0,0,1,0,3Z" />
            <path d="M86.26,87.76H41.74a1.5,1.5,0,1,1,0-3H86.26a1.5,1.5,0,0,1,0,3Z" />
        </template>
        <template v-if="cname === 'great'">
            <path d="M64,3A61,61,0,1,1,3,64,61.06,61.06,0,0,1,64,3m0-3a64,64,0,1,0,64,64A64,64,0,0,0,64,0Z" />
            <path d="M85.57,61.33a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,0,1,3,0v9A1.51,1.51,0,0,1,85.57,61.33Z" />
            <path d="M42.43,61.33a1.51,1.51,0,0,1-1.5-1.5v-9a1.5,1.5,0,0,1,3,0v9A1.5,1.5,0,0,1,42.43,61.33Z" />
            <path d="M64,94.81c-.93,0-1.87,0-2.84-.1a40.4,40.4,0,0,1-20.23-7.22A1.5,1.5,0,1,1,42.6,85a37.39,37.39,0,0,0,18.72,6.69A37.93,37.93,0,0,0,85.41,85a1.5,1.5,0,1,1,1.7,2.46A41.09,41.09,0,0,1,64,94.81Z" />
        </template>
        <template v-if="cname === 'excellent'">
            <path d="M64,3A61,61,0,1,1,3,64,61.06,61.06,0,0,1,64,3m0-3a64,64,0,1,0,64,64A64,64,0,0,0,64,0Z" />
            <path d="M64,94.81c-.93,0-1.87,0-2.84-.1a40.4,40.4,0,0,1-20.23-7.22A1.5,1.5,0,1,1,42.6,85a37.39,37.39,0,0,0,18.72,6.69A37.93,37.93,0,0,0,85.41,85a1.5,1.5,0,0,1,2.08.38,1.48,1.48,0,0,1-.38,2.08A41.09,41.09,0,0,1,64,94.81Z" />
            <path d="M36.87,60.63a1.53,1.53,0,0,1-.71-.18,1.5,1.5,0,0,1-.61-2,9.39,9.39,0,0,1,16.56,0,1.5,1.5,0,0,1-2.65,1.42,6.39,6.39,0,0,0-11.27,0A1.51,1.51,0,0,1,36.87,60.63Z" />
            <path d="M92.52,60.63a1.51,1.51,0,0,1-1.32-.79,6.39,6.39,0,0,0-11.27,0,1.5,1.5,0,1,1-2.64-1.42,9.38,9.38,0,0,1,16.55,0,1.5,1.5,0,0,1-.61,2A1.53,1.53,0,0,1,92.52,60.63Z" />
        </template>
        <template v-if="cname === 'empty'">
            <path d="M64,3A61,61,0,1,1,3,64,61.06,61.06,0,0,1,64,3m0-3a64,64,0,1,0,64,64A64,64,0,0,0,64,0Z" />
        </template>
        <!-- eslint-enable @stylistic/max-len -->
    </svg>
</template>

<script>
import { isNumber } from '@aretheyhappy/utils';

const SCALE_MAP = {
    nps: val => {
        if (val <= 0) return 'bad';
        if (val <= 30) return 'good';
        if (val <= 70) return 'great';
        return 'excellent';
    },
    csat: val => {
        if (val <= 40) return 'bad';
        if (val <= 60) return 'good';
        if (val <= 80) return 'great';
        return 'excellent';
    },
    ces: val => {
        if (val < 2.5) return 'bad';
        if (val < 3.5) return 'good';
        if (val < 4.5) return 'great';
        return 'excellent';
    },
    score: val => {
        if (val < 60) return 'bad';
        if (val <= 70) return 'good';
        if (val <= 80) return 'great';
        return 'excellent';
    },
};

export default {
    name: 'mead-smiley',
    props: {
        /**
         * The score value used to pick the smiley face expression. When not a
         * number, the "empty" (neutral, no face) expression is shown.
         */
        score: {type: [Boolean, Number], default: () => 0},
        /**
         * Which scale's thresholds to use when mapping `score` to an expression.
         * One of "nps", "csat", "ces", or "score" (default); falls back to
         * "score" if an unrecognized value is passed.
         */
        scale: {type: String, default: () => 'score'},
    },
    computed: {
        cname: function () {
            if (!isNumber(this.score)) return 'empty';
            return SCALE_MAP[SCALE_MAP.hasOwnProperty(this.scale) ? this.scale : 'score'](this.score);
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../../../sass/variables' as *;

svg {
    display: inline-block;
    width: 7.7rem;
    height: 7.7rem;
    overflow: visible;
}

path {
    fill: none;
    stroke-width: 3;
    stroke-linecap: round;
}

@mixin val ($name, $col) {
    svg.#{$name} path {
        stroke: $col;
    }
}

@include val('empty',       var(--c-brand-light-bg));
@include val('bad',         var(--c-sentiment-negative-bg));
@include val('good',        var(--c-sentiment-warning-bg));
@include val('great',       var(--c-sentiment-positive-bg));
@include val('excellent',   var(--c-sentiment-positive-bg));
</style>
